import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const wave = keyframes`
  0% {
    height: 10px;
  }
  50% {
    height: 40px;
  }
  100% {
    height: 10px;
  }
`;

const LoadingContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Logo = styled.img`
  width: 150px;
  height: auto;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  animation: ${pulse} 2s infinite ease-in-out;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
`;

const WaveContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 50px;
`;

const WaveBar = styled.div<{ delay: number }>`
  width: 6px;
  height: 10px;
  background-color: ${({ theme }) => theme.colors.accent};
  border-radius: 3px;
  animation: ${wave} 1s infinite ease-in-out;
  animation-delay: ${({ delay }) => delay}s;
`;

const LoadingText = styled.p`
  color: ${({ theme }) => theme.colors.background};
  font-size: 1.2rem;
  margin-top: ${({ theme }) => theme.spacing.xl};
  font-family: ${({ theme }) => theme.fonts.heading};
`;

interface LoadingScreenProps {
  isLoading: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ isLoading }) => {
  const bars = Array.from({ length: 5 }, (_, i) => i);

  return (
    <LoadingContainer
      initial={{ opacity: 1 }}
      animate={{ opacity: isLoading ? 1 : 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{ display: isLoading ? 'flex' : 'none' }}
    >
      <Logo src="/radyofone-logo.png" alt="Radyofone Logo" />
      <WaveContainer>
        {bars.map((i) => (
          <WaveBar key={i} delay={i * 0.1} />
        ))}
      </WaveContainer>
      <LoadingText>Loading Your Music Experience...</LoadingText>
    </LoadingContainer>
  );
};

export default LoadingScreen;
